import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AssignmentTurnedInIcon(props: IconProps) {
    return <Icon {...props} iconKey={"assignment_turned_in"}/>
}
